<template>
  <div>
    <form @submit.prevent="submit">
      <div class="pl-2 pr-4 py-4">
        <div class="columns is-mobile is-variable is-1 is-vcentered">
          <div class="column is-narrow">
            <b-tooltip label="Kembali" type="is-dark">
              <button
                type="button"
                class="button is-white"
                @click="$router.go(-1)"
              >
                <b-icon icon="arrow-left"></b-icon>
              </button>
            </b-tooltip>
          </div>
          <div class="column">
            <h1 class="title is-5 has-text-weight-medium">
              {{ onEdit ? "Ubah" : "Tambah" }}
            </h1>
          </div>
          <div class="column is-narrow has-text-right">
            <b-button
              :class="{ 'is-hidden': activeTab !== 0 }"
              native-type="submit"
              type="is-primary"
              icon-left="check-bold"
            >
              Simpan
            </b-button>
          </div>
        </div>
      </div>

      <div class="p-4" style="max-width: 500px">
        <b-tabs
          v-model="activeTab"
          type="is-boxed"
          :class="{ 'c-tabs-full': true, 'c-tabs-nav-hide': !onEdit }"
        >
          <b-tab-item label="Profil" icon="information-outline">
            <b-notification
              type="is-danger"
              aria-close-label="Tutup"
              role="alert"
              v-if="error"
              :closable="false"
            >
              {{ error | capitalize }}
            </b-notification>

            <b-field label="Nama Unit Kerja *">
              <b-input v-model="name" required></b-input>
            </b-field>

            <b-field label="Latitude *">
              <b-input type="number" step="0.0000001" v-model="latitude" required></b-input>
            </b-field>

            <b-field label="Longitude *">
              <b-input type="number" step="0.0000001" v-model="longitude" required></b-input>
            </b-field>

            <hr />

            <b-field>
              <template #label>
                Mode WFH *
                <b-tooltip
                  multilined
                  type="is-dark"
                  label="Validasi jarak dimatikan dalam mode WFH saat absensi"
                >
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-switch v-model="isWfh">Aktif</b-switch>
            </b-field>

            <b-field label="Jarak Maks. WFO *">
              <b-input
                type="number"
                v-model="maxDistance"
                required
                :disabled="isWfh"
                :expanded="false"
              ></b-input>
              <p class="control">
                <span class="button is-static">meter</span>
              </p>
            </b-field>

            <b-field>
              <template #label>
                Toleransi terlambat *
                <b-tooltip
                  multilined
                  type="is-dark"
                  label="Tandai terlambat jika check-in setelah melewati batas toleransi"
                >
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-select v-model="checkInTolerance">
                <option value="0">Tidak ada</option>
                <option value="15">15 menit</option>
                <option value="2">30 menit</option>
                <option value="3">45 menit</option>
                <option value="3">1 jam</option>
              </b-select>
            </b-field>

            <b-field>
              <template #label>
                Toleransi pulang *
                <b-tooltip
                  multilined
                  type="is-dark"
                  label="Tandai jam kerja kurang jika check-out sebelum batas toleransi"
                >
                  <b-icon size="is-small" icon="help-circle-outline"></b-icon>
                </b-tooltip>
              </template>
              <b-select v-model="checkOutTolerance">
                <option value="0">Tidak ada</option>
                <option value="15">15 menit</option>
                <option value="2">30 menit</option>
                <option value="3">45 menit</option>
                <option value="3">1 jam</option>
              </b-select>
            </b-field>

            <b-field label="Kontak Perizinan (Whatsapp) *" grouped>
              <b-field>
                <b-input
                  v-model="whatsappNumber"
                  placeholder="6281234567890"
                ></b-input>
              </b-field>

              <p class="control">
                <b-button
                  tag="a"
                  :href="`https://wa.me/${whatsappNumber}`"
                  target="_blank"
                  icon-pack="mdi"
                  icon-right="chevron-right"
                  type="is-primary"
                  :disabled="!whatsappNumber"
                >
                  Buka
                </b-button>
              </p>
            </b-field>

            <br />

            <small>
              <i><span class="mr-2">*</span> : Wajib diisi</i>
            </small>
          </b-tab-item>

          <b-tab-item label="Shift" icon="cached">
            <div
              class="columns is-variable is-2 is-mobile is-vcentered c-has-border-bottom"
              v-for="(shift, index) in shiftsData"
              :key="`shift-${shift.id}`"
            >
              <div class="column is-narrow has-text-weight-medium">
                Shift {{ index + 1 }}
              </div>
              <div class="column is-narrow">
                ({{ timeUtcToTimeStringlocal(shift.start_at) }}
                -
                {{ timeUtcToTimeStringlocal(shift.end_at) }})
              </div>
              <div class="column is-narrow has-text-weight-medium">
                <b-tooltip label="Jumlah pegawai" type="is-dark">
                  <b-icon icon="account" size="is-small"></b-icon>
                  {{ shift.employee_count }}
                </b-tooltip>
              </div>
              <div class="column has-text-right has-text-weight-medium">
                <a @click="() => showEditShift(shift)" class="has-text-primary"
                  >Ubah</a
                >
              </div>
              <div class="column is-narrow has-text-weight-medium">
                <a
                  @click="deleteDialog(shift)"
                  class="has-text-danger"
                  v-if="shift.employee_count === 0"
                  >Hapus</a
                >
                <b-tooltip
                  label="Harap pindahkan seluruh pegawai dari Shift ini sebelum menghapus"
                  type="is-dark"
                  multilined
                  v-else
                >
                  <span class="has-text-grey">Hapus</span>
                </b-tooltip>
              </div>
            </div>
            <a @click="showCreateShift" class="has-text-primary">
              <b-icon icon="plus-thick" size="is-small"></b-icon>
              Tambah Shift
            </a>
          </b-tab-item>
        </b-tabs>
      </div>
    </form>
  </div>
</template>

<script>
import CFormPopup from "@/components/CFormPopup";
import CShiftForm from "@/components/CShiftForm";
import CDialogPopup from "@/components/CDialogPopup";

export default {
  name: "UnitForm",
  data() {
    return {
      error: "",
      activeTab: 0,
      id: this.$route.params.id,
      name: "",
      latitude: "",
      longitude: "",
      shiftsData: "",
      isWfh: false,
      whatsappNumber: "",
      maxDistance: "",
      checkInTolerance: "",
      checkOutTolerance: ""
    };
  },
  methods: {
    loadEmployeeUnit() {
      const loadingComponent = this.$buefy.loading.open();

      this.$http({
        url: `employee_units/${this.id}`,
        method: "GET"
      })
        .then(res => {
          const data = res.data.data;

          this.name = data.name;
          this.latitude = data.latitude;
          this.longitude = data.longitude;
          this.isWfh = !data.is_wfo;
          this.whatsappNumber = data.contact_phone_number;
          this.maxDistance = data.wfo_max_distance;
          this.checkInTolerance = data.check_in_tolerance;
          this.checkOutTolerance = data.check_out_tolerance;

          this.loadUnitShifts();

          loadingComponent.close();
        })
        .catch(() => {
          loadingComponent.close();

          this.$buefy.snackbar.open({
            message: "Gagal memuat daftar Unit Kerja",
            type: "is-warning",
            duration: 5000,
            actionText: "Coba Lagi",
            onAction: () => {
              this.loadEmployeeUnit();
            }
          });
        });
    },
    loadUnitShifts() {
      this.isLoadingUnitShifts = true;

      this.$http({
        url: `employee_units/${this.id}/shifts`,
        method: "GET"
      })
        .then(res => {
          this.shiftsData = res.data.data;
          this.isLoadingUnitShifts = false;
        })
        .catch(() => {
          this.isLoadingUnitShifts = false;

          this.$buefy.snackbar.open({
            message: "Gagal memuat daftar Shift Unit",
            type: "is-warning",
            duration: 5000,
            actionText: "Coba Lagi",
            onAction: () => {
              this.loadUnitShifts();
            }
          });
        });
    },
    submit() {
      this.error = "";
      const loadingComponent = this.$buefy.loading.open();

      const mode = this.getRequestProps({
        id: this.id,
        onEdit: this.onEdit,
        basePath: "employee_units",
        modelName: "Unit Kerja"
      });

      this.$http({
        url: mode.url,
        method: mode.method,
        data: {
          name: this.name,
          latitude: this.latitude,
          longitude: this.longitude,
          is_wfo: !this.isWfh,
          contact_phone_number: this.whatsappNumber,
          wfo_max_distance: this.maxDistance,
          check_in_tolerance: this.checkInTolerance,
          check_out_tolerance: this.checkOutTolerance
        }
      })
        .then(res => {
          this.$buefy.toast.open({
            message: `Berhasil ${mode.message} <i class="mdi mdi-check-bold has-text-success"></i>`
          });

          loadingComponent.close();

          if (this.onEdit) {
            this.$router.push({ name: "unit" });
            return;
          }

          this.shiftsData = res.data.data;
          this.id = this.shiftsData.id;
          this.activeTab = 1;

          this.loadUnitShifts();
        })
        .catch(error => {
          loadingComponent.close();

          if (error.response.status === 400) {
            const errors = error.response.data.errors;
            this.error = errors[Object.keys(errors)[0]][0];
            return;
          }

          this.$buefy.snackbar.open({
            message: `Gagal ${mode.message}`,
            type: "is-warning",
            duration: 5000,
            actionText: "Retry",
            onAction: () => {
              this.submit();
            }
          });
        });
    },
    submitShift({ id, onEdit = false, startAt, endAt }) {
      this.error = "";
      const loadingComponent = this.$buefy.loading.open();

      const mode = this.getRequestProps({
        id: id,
        onEdit: onEdit,
        basePath: `employee_units/${this.id}/shifts`,
        modelName: "Shift"
      });

      this.$http({
        url: mode.url,
        method: mode.method,
        data: {
          start_at: startAt,
          end_at: endAt
        }
      })
        .then(() => {
          this.$buefy.toast.open({
            message: `Berhasil ${mode.message} <i class="mdi mdi-check-bold has-text-success"></i>`
          });

          this.loadUnitShifts();
          loadingComponent.close();
        })
        .catch(error => {
          loadingComponent.close();

          if (error.response.status === 400) {
            const errors = error.response.data.errors;
            this.error = errors[Object.keys(errors)[0]][0];
            return;
          }

          this.$buefy.snackbar.open({
            message: `Gagal ${mode.message}`,
            type: "is-warning",
            duration: 5000,
            actionText: "Retry",
            onAction: () => {
              this.submit();
            }
          });
        });
    },
    showCreateShift(shift) {
      this.$buefy.modal.open({
        parent: this,
        animation: "zoom-out",
        events: {
          onSubmit: (startTime, endTme) => {
            if (startTime && endTme)
              this.submitShift({
                id: shift.id,
                startAt: this.dateTimeToTimeStringUtc(startTime),
                endAt: this.dateTimeToTimeStringUtc(endTme)
              });
          }
        },
        props: {
          title: "Tambah Shift",
          positiveLabel: "Simpan",
          negativeLabel: "Batal",
          component: CShiftForm
        },
        component: CFormPopup
      });
    },
    showEditShift(shift) {
      this.$buefy.modal.open({
        parent: this,
        animation: "zoom-out",
        events: {
          onSubmit: (startTime, endTme) => {
            if (startTime && endTme)
              this.submitShift({
                id: shift.id,
                onEdit: true,
                startAt: this.dateTimeToTimeStringUtc(startTime),
                endAt: this.dateTimeToTimeStringUtc(endTme)
              });
          }
        },
        props: {
          title: "Ubah Shift",
          positiveLabel: "Simpan",
          negativeLabel: "Batal",
          component: CShiftForm,
          props: {
            startTime: this.timeUtcToDateTimelocal(shift.start_at),
            endTime: this.timeUtcToDateTimelocal(shift.end_at)
          }
        },
        component: CFormPopup
      });
    },
    delete(shift) {
      const loadingComponent = this.$buefy.loading.open();

      this.$http({
        url: `employee_units/${this.id}/shifts/${shift.id}`,
        method: "DELETE"
      })
        .then(() => {
          this.$buefy.toast.open({
            message:
              'Satu Shift berhasil dihapus <i class="mdi mdi-check-bold has-text-success"></i>'
          });

          this.loadUnitShifts();
          loadingComponent.close();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            message: "Gagal menghapus Shift ini",
            type: "is-warning",
            duration: 5000,
            actionText: "Coba Lagi",
            onAction: () => this.delete(shift)
          });

          loadingComponent.close();
        });
    },
    deleteDialog(shift) {
      const name = `Shift ${this.shiftsData.indexOf(shift) + 1}`;

      this.$buefy.modal.open({
        parent: this,
        animation: "zoom-out",
        events: {
          onPositiveAction: () => this.delete(shift)
        },
        props: {
          title: "Hapus Unit Kerja",
          subtitle: `Hapus "${name}" dari daftar Shift? Tindakan ini tidak dapat diurungkan.`,
          positiveLabel: "Hapus",
          negativeLabel: "Batal",
          type: "is-danger"
        },
        component: CDialogPopup
      });
    }
  },
  computed: {
    onEdit() {
      return !!this.id;
    }
  },
  created() {
    if (this.onEdit) this.loadEmployeeUnit();
  }
};
</script>
